import * as React from "react";
import * as HoverCardPrimitive from "@radix-ui/react-hover-card";

import { cn } from "@/lib/utils";

const HoverCard = HoverCardPrimitive.Root;

const HoverCardTrigger = HoverCardPrimitive.Trigger;

const HoverCardContent = React.forwardRef<
  React.ElementRef<typeof HoverCardPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content>
>(
  (
    { className, align = "start", side = "right", sideOffset = 4, collisionPadding, ...props },
    ref,
  ) => {
    // Keep the tooltip from spilling off-screen on the left and from
    // overlapping the sticky calendar header / scrolling past the grid's
    // own scroll container, rather than just the full browser viewport.
    const scrollContainer =
      typeof document !== "undefined"
        ? document.querySelector('[data-calendar-scroll-container="true"]')
        : null;
    const header =
      typeof document !== "undefined"
        ? document.querySelector('[data-calendar-header="true"]')
        : null;
    const headerHeight = header?.getBoundingClientRect().height || 0;

    return (
      // Portal so the tooltip escapes the trigger's local z-20/z-10 stacking
      // context and always paints above sibling appointment/block-out cards.
      <HoverCardPrimitive.Portal>
        <HoverCardPrimitive.Content
          ref={ref}
          align={align}
          side={side}
          sideOffset={sideOffset}
          avoidCollisions
          sticky="always"
          collisionBoundary={scrollContainer || undefined}
          collisionPadding={
            collisionPadding ?? { top: headerHeight + 8, bottom: 8, left: 8, right: 8 }
          }
          className={cn(
            "z-50 w-64 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
            className,
          )}
          {...props}
        />
      </HoverCardPrimitive.Portal>
    );
  },
);
HoverCardContent.displayName = HoverCardPrimitive.Content.displayName;

export { HoverCard, HoverCardTrigger, HoverCardContent };
